import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import { map, mergeAll, toArray } from 'rxjs/operators'

export const ACCOUNTS_URL = `helios-accounts`

export interface LIBDetails {
  isLIB: boolean
  basisDetails: BasisDetailsLIB
}

export interface BasisDetailsLIB {
  DEFAULT_BASIS_ID: number
  ACCOUNT_BASES: Basis[]
}

export interface Basis {
  basisId: number
  basisType: string
  prefix: string
  name: string
}

/**
 * @deprecated - HttpAccountsService should only be used within the SessionsService
 *
 */
@Injectable({
  providedIn: 'root',
})
export class HttpAccountsService {
  constructor(private readonly http: HttpClient) {}

  /**
   * Get the account type and account id for a specific account id
   *
   * @internal
   */
  getAccountType(accountIds: number[]) {
    if (accountIds.length === 0) {
      return of([])
    }
    return this.http
      .post<{ data: [{ accountType: string }] }>(ACCOUNTS_URL, {
        context: {
          filterContext: {
            advancedFilters: {},
            reconDate: new Date(),
          },
        },
        endRow: 1,
        startRow: 0,
        sort: [],
        group: {
          keys: [],
          fields: [],
        },
        fields: ['accountType', 'accountId'],
        filter: {
          accountId: {
            operator: 'AND',
            filterType: 'number',
            filters: [{ operator: 'in', values: accountIds }],
          },
        },
      })
      .pipe(
        map(x => x.data),
        mergeAll(),
        map(x => x.accountType),
        toArray(),
      )
  }

  getLIBDetails(accountId: number): Observable<LIBDetails> {
    return this.http.get<LIBDetails>(`${ACCOUNTS_URL}/${accountId}/lib-details`)
  }
}
